// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"272":"16e3caaeca4ce8a74d1c","558":"d0e2b623c3be3f43ddc7","718":"b5ca068cb54fa3497b07","777":"d071d0bcafafc80a7337"}[chunkId] + ".js";
};